import React from "react";
import Slider from "react-slick";
import { Box, Typography, Button } from "@mui/material";
import { ArrowForwardIos, ArrowBackIos } from "@mui/icons-material";
import { motion } from "framer-motion";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Homepagespices from './images/Homepagespices.webp'
import HomePageonion from './images/HomePageOnion.webp'
import HomePageGarlic from './images/HomePageGarlic.jpg'
import { useNavigate } from 'react-router-dom';

// Theme Colors
const primaryColor = "#1F473E";
const secondaryColor = "#D4C9B6";

// Floating Animation Variants
const floatAnimation = {
  animate: {
    y: [0, -10, 0], // Moves up and down
    transition: {
      duration: 2,
      repeat: Infinity,
      ease: "easeInOut",
    },
  },
};

// Custom Arrow Components with Hover Effect
const NextArrow = ({ onClick }) => (
  <ArrowForwardIos 
    onClick={onClick} 
    sx={{ 
      position: "absolute", 
      top: "50%", 
      right: "15px", 
      zIndex: 10, 
      cursor: "pointer", 
      fontSize: 40, 
      color: secondaryColor, 
      background: primaryColor, 
      borderRadius: "50%", 
      padding: "5px",
      transition: "0.3s",
      "&:hover": { transform: "scale(1.2)", background: secondaryColor, color: primaryColor }
    }}
  />
);

const PrevArrow = ({ onClick }) => (
  <ArrowBackIos 
    onClick={onClick} 
    sx={{ 
      position: "absolute", 
      top: "50%", 
      left: "15px", 
      zIndex: 10, 
      cursor: "pointer", 
      fontSize: 40, 
      color: secondaryColor, 
      background: primaryColor, 
      borderRadius: "50%", 
      padding: "5px",
      transition: "0.3s",
      "&:hover": { transform: "scale(1.2)", background: secondaryColor, color: primaryColor }
    }}
  />
);

const Carousel = () => {

  const navigate = useNavigate();


  const settings = {
    dots: true,
    infinite: true,
    speed: 800,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
    arrows: true,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
  };

  const slides = [
    // {
    //   image: "https://images.unsplash.com/photo-1604467794349-0b74285de7e7?fm=jpg&q=60&w=3000&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Nnx8a2lkcyUyMGNsb3RoZXN8ZW58MHx8MHx8fDA%3D",
    //   title: "Trendy Kids Clothing Collection",
    //   description: "Discover the latest styles and comfort for your little ones.",
    //   buttonText: "Shop Now",
    // },
    
    {
      image: Homepagespices,
      title: "Exotic Dehydrated Vegetables & Spices from Around the World",
      description: "Bring authentic flavors to your kitchen with our premium Dehydrated Vegetables & spices.",
      buttonText: "Contact Now",
    },
    {
      image: HomePageonion,
      title: "Fresh Red onion powder",
      description: "Experience the rich flavor and aroma of our premium red onion powder, sourced from the finest farms.",
      buttonText: "Contact Now",
    },
    {
      image: HomePageGarlic,
      title: "Fresh garlic powder",
      description: "Experience the rich flavor and aroma of our premium garlic powder, sourced from the finest farms.",
      buttonText: "Contact Now",
    },
  ];

  return (
    <Box sx={{ width: "100%", height: "90vh", overflow: "hidden", position: "relative" }}>
      <Slider {...settings}>
        {slides.map((slide, index) => (
          <Box 
            key={index} 
            sx={{ 
              height: "90vh", 
              display: "flex", 
              alignItems: "center", 
              justifyContent: "center", 
              background: `url(${slide.image}) center/cover no-repeat`,
              width: "100%"
            }}
          >
            <Box sx={{ 
              background: "rgba(31, 71, 62, 0.3)", // Themed overlay
              color: secondaryColor, 
              padding: "20%", 
              borderRadius: "10px", 
              textAlign: "center",
              boxShadow: "0px 4px 10px rgba(0,0,0,0.2)"
            }}>
              {/* Floating Title */}
              <motion.div variants={floatAnimation} animate="animate">
                <Typography 
                  variant="h2" 
                  sx={{ fontFamily: "'Playfair Display', serif", fontWeight: "bold", marginBottom: "10px" }}
                >
                  {slide.title}
                </Typography>
              </motion.div>

              {/* Floating Description */}
              <motion.div variants={floatAnimation} animate="animate">
                <Typography 
                  variant="h5" 
                  sx={{ fontFamily: "'Playfair Display', serif", marginBottom: "20px" }}
                >
                  {slide.description}
                </Typography>
              </motion.div>

              {/* Floating Button */}
              <motion.div variants={floatAnimation} animate="animate">
                <Button 
                  variant="contained" 
                  sx={{ backgroundColor: secondaryColor, color: primaryColor, fontWeight: "bold" }}
                   onClick={() => navigate('/contact')}
                >
                  {slide.buttonText}
                </Button>
              </motion.div>
            </Box>
          </Box>
        ))}
      </Slider>
    </Box>
  );
};

export default Carousel;
